import { useEffect } from 'react';
import calApi from '../api/calApi';
import { logBookingError } from '../loggingUtils';
import { CalEventData } from '../types';

interface UseCalEventDataParams {
    teamId?: number;
    organizationId?: number;
    eventSlug?: string;
}

interface UseCalEventDataCallbacks {
    onSuccess: (data: CalEventData) => void;
}

const useCalEventData = (
    { teamId, organizationId, eventSlug }: UseCalEventDataParams,
    { onSuccess }: UseCalEventDataCallbacks
) => {
    useEffect(() => {
        if (teamId && organizationId && eventSlug) {
            calApi
                .getTeamEventType({
                    orgId: organizationId,
                    eventSlug,
                    teamId,
                })
                .then(onSuccess)
                .catch((err) => {
                    logBookingError('Failed to get cal event type by slug', {
                        errorMessage: err.message,
                        additionalInfoToLog: {
                            teamId,
                            organizationId,
                            eventSlug,
                        },
                    });
                });
        }
    }, [teamId, organizationId, eventSlug]);
};

export default useCalEventData;
